(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[724],{

/***/ 61256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33546);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39234);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46133);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children", "className", "onPrimaryBg"],
    _excluded2 = ["node", "children", "href"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StyledA = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      $onPrimaryBg = _ref.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.main : theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme,
      $onPrimaryBg = _ref2.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.mainHover : theme.colors.text;
});
var StyledReactMarkdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_markdown__WEBPACK_IMPORTED_MODULE_6__/* .ReactMarkdown */ .D)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  line-height: 1.6;\n  font-size: 1.6rem;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
});

var MarkdownText = function MarkdownText(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      onPrimaryBg = _ref4.onPrimaryBg,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref4, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledReactMarkdown, _objectSpread(_objectSpread({}, props), {}, {
    className: "markdown-text-wrapper ".concat(className),
    rehypePlugins: [rehype_raw__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z],
    components: {
      a: function a(_ref5) {
        var node = _ref5.node,
            children = _ref5.children,
            href = _ref5.href,
            aProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref5, _excluded2);

        var isExternal = href.startsWith('http');
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: href,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledA, _objectSpread(_objectSpread({}, aProps), {}, {
            target: isExternal ? '_blank' : undefined,
            rel: isExternal ? 'noopener' : undefined,
            $onPrimaryBg: onPrimaryBg,
            children: children
          }))
        });
      }
    },
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (MarkdownText);

/***/ }),

/***/ 52816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TitleH1 */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46133);
/* harmony import */ var _atoms_markdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61256);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;





var GradientText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .ZP.span(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  background: ", ";\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryGradient;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  margin-bottom: ", ";\n\n  @media screen and (max-width: ", ") {\n    padding: 0 1rem;\n    margin-bottom: ", ";\n  }\n"])), function (_ref2) {
  var $marginBottom = _ref2.$marginBottom;
  return $marginBottom ? $marginBottom : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref4) {
  var $marginBottom = _ref4.$marginBottom;
  return $marginBottom ? "calc(".concat($marginBottom, " / 2)") : 0;
});
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 3rem;\n"])));
var Description = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p */ .ZP.p(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: center;\n  margin: initial;\n  font-weight: initial;\n  line-height: 1.6;\n  font-size: 1.6rem;\n  font-weight: 500;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n  color: ", ";\n\n  max-width: 800px;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text;
});
var TitleH1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1 */ .ZP.h1(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  text-align: center;\n  font-size: 46px;\n  @media screen and (max-width: ", ") {\n    font-size: 3rem;\n  }\n  color: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.headingFontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text;
});
var StyledMarkdownContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  max-width: 800px;\n  text-align: center;\n  p {\n    font-family: Inter, sans-serif;\n    text-align: center;\n    margin: initial;\n    line-height: 1.6;\n    font-size: 1.6rem;\n    font-weight: 500;\n    color: ", ";\n    max-width: 800px;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.text;
});

var PageTitle = function PageTitle(_ref12) {
  var title = _ref12.title,
      description = _ref12.description,
      $marginBottom = _ref12.$marginBottom;

  var _split = (title || '').split('<gradient>'),
      _split2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_split, 3),
      before = _split2[0],
      gradientText = _split2[1],
      after = _split2[2];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
    $marginBottom: $marginBottom,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Inner, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TitleH1, {
        children: [before, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GradientText, {
          children: gradientText
        }), after]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledMarkdownContainer, {
        style: {},
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_markdown__WEBPACK_IMPORTED_MODULE_0__["default"], {
          children: description
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);

/***/ }),

/***/ 28035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var SEO = function SEO(_ref) {
  var _openGraphImage$data;

  var propTitle = _ref.title,
      metaTitle = _ref.metaTitle,
      metaDescription = _ref.metaDescription,
      twitterCard = _ref.twitterCard,
      twitterSite = _ref.twitterSite,
      twitterCreator = _ref.twitterCreator,
      openGraphImage = _ref.openGraphImage,
      noindex = _ref.noindex,
      jsonSchema = _ref.jsonSchema;
  var title = propTitle || metaTitle;
  var ogImage = openGraphImage === null || openGraphImage === void 0 ? void 0 : (_openGraphImage$data = openGraphImage.data) === null || _openGraphImage$data === void 0 ? void 0 : _openGraphImage$data.attributes;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
        children: title
      }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:title",
        content: title
      }, "og:title")]
    }), metaDescription && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "description",
        content: metaDescription
      }, "description"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:description",
        content: metaDescription
      }, "twitter:description")]
    }), twitterCard && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:card",
      content: twitterCard
    }, "twitter:card"), twitterSite && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:site",
      content: twitterSite
    }, "twitter:site"), twitterCreator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:creator",
      content: twitterCreator
    }, "twitter:creator"), ogImage && (ogImage === null || ogImage === void 0 ? void 0 : ogImage.url) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image",
        content: ogImage.url
      }, "og:image"), ogImage.width && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:width",
        content: ogImage.width
      }, "og:image:width"), ogImage.height && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:height",
        content: ogImage.height
      }, "og:image:height"), ogImage.alternativeText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:alt",
        content: ogImage.alternativeText
      }, "og:image:alt"), ogImage.mime && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:type",
        content: ogImage.mime
      }, "og:image:type")]
    }), jsonSchema && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(jsonSchema)
      }
    }, "jsonSchema"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "robots",
      content: noindex ? 'noindex' : 'index follow'
    }, "robots")]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SEO);

/***/ }),

/***/ 9577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ AuthorPage; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var components_layout_pageTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52816);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28035);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var BlogList = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(907)]).then(__webpack_require__.bind(__webpack_require__, 2798));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2798)];
    }
  }
});
var __N_SSG = true;
function AuthorPage(_ref) {
  var seoData = _ref.seoData,
      name = _ref.name,
      bio = _ref.bio,
      blogs = _ref.blogs;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, seoData)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_layout_pageTitle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      title: "<gradient>".concat(name, "<gradient>"),
      description: bio
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(BlogList, {
      blogs: blogs || []
    })]
  });
}

/***/ }),

/***/ 15675:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[slug]",
      function () {
        return __webpack_require__(9577);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [546,234,774,888,179], function() { return __webpack_exec__(15675); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);